import styling from "Services/styling";

export default {
	wrapper: (isDisabled) => ({
		position: "relative",
		opacity: isDisabled ? 0.5 : 1,
		height: 0,
		overflow: "hidden",
		cursor: isDisabled ? "loading" : void 0,
		...styling.mixins.transition("opacity"),
	}),
	inputCover: {
		position: "absolute",
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 2,
	},
	input: {
		color: styling.colors.inputText,
		caretColor: styling.colors.primary,
		fontSize: "1.4rem",
		lineHeight: "1.8rem",
		width: "100%",
		outline: "none",
		...styling.mixins.padding(21, 10),
		backgroundColor: styling.colors.inputBackground,
		...styling.mixins.borderRadius(4),
		...styling.mixins.border([1, "solid", styling.colors.inputBorder]),
		...styling.mixins.transition("border-color"),
		":focus": {
			...styling.mixins.border([1, "solid", styling.colors.inputBorder]),
		},
		...styling.mixins.placeholder({
			color: styling.colors.inputBorder,
		}),
	},
};
